import React from "react";
import * as H from "history";
import { HeaderDropdown } from "./HeaderDropdown";
import { Link } from "react-router-dom";
import classNames from "classnames";
import styles from ".././header.css";
import { useWindowDimensions, WindowSize } from "../../../models/WindowDimensions";

export interface HeaderTabOption {
  to:
    | H.LocationDescriptor<unknown>
    | ((location: H.Location<unknown>) => H.LocationDescriptor<unknown>);
  id: string;
  name: string;
  isEnabled: boolean;
  isActive: boolean;
}

interface Props {
  tabs: HeaderTabOption[];
}

export const HeaderTabs = ({ tabs }: Props) => {
  const { windowSize } = useWindowDimensions();

  switch (windowSize) {
    case WindowSize.Default: {
      return (
        <>
          {tabs
            .filter((tab) => tab.isEnabled)
            .map((tab) => (
              <Link
                to={tab.to}
                id={tab.id}
                key={tab.id}
                className={classNames(styles["menu-option"], {
                  [styles["menu-option-active"]]: tab.isActive
                })}
              >
                {tab.name}
              </Link>
            ))}
        </>
      );
    }
    default: {
      return <HeaderDropdown tabs={tabs} />;
    }
  }
};
